export default __webpack_public_path__ + "static/media/BlogBuddyPreview.f5a292a2.png";